import SectionHeading from "@/pages/home/components/SectionHeading";
import { welfareSteps } from "@/mocks/content";

export default function WelfareAccess() {
  return (
    <section id="welfare" className="w-full bg-background-50 py-16 md:py-24 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="福利内容观看方式"
          title="福利内容怎么找、怎么看"
          desc="福利内容不是独立站点，而是分布在各分区与短视频标签里，按账号权限与时段开放。下面五步是完整路径，按顺序确认即可，不必反复重试。"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          <ol className="relative border-l border-background-300 pl-8 space-y-8">
            {welfareSteps.map((s) => (
              <li key={s.step} className="relative">
                <span className="absolute -left-[45px] top-0 w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-background-50 font-heading font-bold text-sm">
                  {s.step}
                </span>
                <h3 className="font-heading font-bold text-lg text-foreground-950">{s.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{s.desc}</p>
              </li>
            ))}
          </ol>

          <aside className="lg:sticky lg:top-24 h-max space-y-4">
            <div className="rounded-lg overflow-hidden relative">
              <img
                src="https://readdy.ai/api/search-image?query=abstract%20glowing%20gift%20box%20with%20warm%20coral%20and%20golden%20amber%20light%20rays%20on%20a%20dark%20background%2C%20stylized%20premium%20editorial%20visual%2C%20soft%20haze%20and%20bokeh%2C%20no%20text&width=900&height=640&seq=km-welfare-panel-01&orientation=landscape"
                alt=""
                className="w-full h-48 md:h-56 object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
              <div className="absolute bottom-4 left-5 right-5">
                <div className="font-heading font-bold text-background-50 text-lg">入口分散，别单独找</div>
                <p className="text-xs text-background-200 mt-1">福利内容跟随分区与标签显示，主站入口即是唯一路径。</p>
              </div>
            </div>

            <div className="rounded-lg bg-secondary-50 border border-secondary-200/70 p-5 md:p-6">
              <h3 className="font-heading font-bold text-base text-foreground-950 flex items-center gap-2">
                <i className="ri-shield-check-line text-secondary-600"></i>
                观看前先确认三件事
              </h3>
              <ul className="mt-4 space-y-3 text-sm text-foreground-700">
                <li className="flex items-start gap-2">
                  <i className="ri-account-circle-line text-secondary-600 mt-0.5"></i>
                  账号层级：游客 / 注册用户 / VIP 能看到的内容范围不同。
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-time-line text-secondary-600 mt-0.5"></i>
                  时段：深夜档内容在固定时段开放，白天可能不显示。
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-notification-2-line text-secondary-600 mt-0.5"></i>
                  站内公告：范围或时间调整时会通过公告说明。
                </li>
              </ul>
            </div>

            <div className="rounded-lg bg-accent-50 border border-accent-200/70 p-5 md:p-6 flex items-start gap-3">
              <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-lg bg-accent-500 text-background-50">
                <i className="ri-alert-line"></i>
              </span>
              <p className="text-sm text-foreground-700 leading-relaxed">
                若某条内容显示「暂不可见」，通常是账号层级或时段未满足，按页面提示处理即可，无需重复刷新。
              </p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}